export enum EnumMapUrl {
    Unilever = "/unifiedZonesMap",
    Helados_Holanda = "/unifiedZonesMap",
    GPS = "/unifiedMap"
}

export enum EnumExternalMapUrl {
    Engineer= "/technicianMap",
    Ticket = "/ticketMap",
    Business = "/businessMap"
}


export enum EnumUnifiedMapUrlByCustomerTypeId {
    uno = "/unifiedMap",
    dos = "/unifiedZonesMap"
}

export enum EnumCustomerTypeIdMainCategoryIcon {
    Unilever = "engineer.png",
    Helados_Holanda = "engineer.png",
    GPS = "car.png",
}